import { render, staticRenderFns } from "./SettingPrice.vue?vue&type=template&id=04d4b67a&"
import script from "./SettingPrice.vue?vue&type=script&lang=js&"
export * from "./SettingPrice.vue?vue&type=script&lang=js&"
import style0 from "./SettingPrice.vue?vue&type=style&index=0&id=04d4b67a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports